import { useEffect } from "react";

import { useListingData } from "~/context/ListingPageDataContext";

import { useStatsigUserContext } from "./StatsigUserProvider";

/**
 * Listing-page adapter for the global Statsig user: pushes this listing's
 * targeting attributes (metro, use type, country, FSV) onto the shared user via
 * the single-writer `setAttributes`.
 *
 * Runs as soon as the critical fields are present (available on first paint via
 * ListingPageDataProvider). `setAttributes` is idempotent, so re-renders and the
 * "already matches" case are no-ops handled by the provider.
 */
export const useStatsigListingPageUserUpdate = () => {
  const { setAttributes } = useStatsigUserContext();
  const { data } = useListingData();

  useEffect(() => {
    if (!data.metro || !data.useType || !data.listingCountry) {
      return;
    }

    setAttributes({
      full_service: !!data.fullService?.active,
      listingCountry: data.listingCountry,
      search_metro: data.metro,
      useType: data.useType,
    });
  }, [
    data.fullService?.active,
    data.listingCountry,
    data.metro,
    data.useType,
    setAttributes,
  ]);
};
